import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Field from '../../../../../../components/Form/Field'
import ToggleField from '../../../../../../components/Form/ToggleField'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'
import CampaignObjectiveField from './CampaignObjectiveField'

import { formatNumber } from '../../../../../../helpers/numbers'

import { selectedTikTokAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { BUDGET_DAILY, BUDGET_LIFETIME, OBJECTIVE } from '../../../../../Multiplatform/CampaignForms/fields'
import { REACH } from '../../../../../../constants/campaigns'
import { AUTO_OPTIMIZED_CAMPAIGN_BUDGET } from '../../../../../reusableFields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'
import useAutoOptimiseToggleLabelStyles from '../../../../../../styles/common/autoOptimiseToggleLabelStyles'

import { BUDGET_OPTION } from '../../../../../Multiplatform/fields'

const NewCampaignBudgetFields = ({ formik, remainingBudget }) => {
  const drawerFormClasses = useDrawerFormStyles()
  const classes = useAutoOptimiseToggleLabelStyles()

  const { t } = useTranslation()

  const { currency_symbol: currencySymbol } = useSelector(selectedTikTokAdAccountSelector)

  const { values, setFieldValue } = formik

  const showBudgetSection = values[OBJECTIVE] !== REACH

  if (remainingBudget < 1) {
    return <ErrorMessage fontSize={14} error="Your total remaining budget is too low to create a campaign." />
  }

  return (
    <>
      <div className={drawerFormClasses.subSection}>
        <CampaignObjectiveField formik={formik} />
      </div>
      {showBudgetSection && (
        <div className={drawerFormClasses.subSection}>
          <ToggleField
            name={AUTO_OPTIMIZED_CAMPAIGN_BUDGET}
            isEnabled={values[AUTO_OPTIMIZED_CAMPAIGN_BUDGET]}
            setFieldValue={setFieldValue}
            label={'Auto optimised campaign budget'}
            labelClassName={classes.autoOptimiseToggleLabel}
            isSolid={false}
          />
          {!!values[AUTO_OPTIMIZED_CAMPAIGN_BUDGET] && (
            <>
              {/* Budget type selection is temporarily commented out, because for now we need only lifetime budget*/}
              {/*todo uncomment when needed*/}
              {/*<BudgetTypeField formik={formik} />*/}
              {values[BUDGET_OPTION] === BUDGET_LIFETIME ? (
                <p>{t('Set your lifetime budget for campaign')}</p>
              ) : (
                <p>{t('Set your daily budget for campaign')}</p>
              )}
              <p>
                {t(
                  'Please set a budget for this campaign. The budget will be shared across ad sets according to performance.'
                )}
              </p>
              <p>{t(`Your remaining budget is ${currencySymbol}` + formatNumber(remainingBudget, { max: 2 }))}</p>
              <Field
                placeholder="Budget"
                type="number"
                formik={formik}
                name={values[BUDGET_OPTION] === BUDGET_LIFETIME ? BUDGET_LIFETIME : BUDGET_DAILY}
                key={values[BUDGET_OPTION] === BUDGET_LIFETIME ? BUDGET_LIFETIME : BUDGET_DAILY}
                symbol={currencySymbol}
                inputMode="numeric"
              />
            </>
          )}
        </div>
      )}
    </>
  )
}

export default NewCampaignBudgetFields
